import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlTree } from '@angular/router';
import { CognitoAuthService } from '@auth/services/cognito-auth.service';
import { concatMap, map } from 'rxjs/operators';
import { RdrAuthService } from '@auth/services/rdr-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private rdrAuth: RdrAuthService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.cognitoAuthService.hasCognitoSession().pipe(
      concatMap(() => this.rdrAuth.getUser()),
      map(() => true),
    );
  }
}
